import React from 'react';
import { useSelector } from 'react-redux';
import { getFlags } from '../selectors';
import { FlagContext } from '@wix/da-react-context/pkg/flags/FlagContext';
var ConnectedFlagsProvider = function (_a) {
    var children = _a.children;
    var flags = useSelector(getFlags);
    return React.createElement(FlagContext.Provider, { value: flags }, children);
};
ConnectedFlagsProvider.displayName = 'ConnectedFlagsProvider';
export default ConnectedFlagsProvider;
//# sourceMappingURL=ConnectedFlagsProvider.js.map